export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"author","content":"taminify.com"},{"name":"robots","content":"follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-title","content":"Taminify"}],"link":[{"rel":"canonical","href":"https://taminify.com"},{"type":"image/png","href":"/favicon/favicon-96x96.png","sizes":"96x96"},{"type":"image/svg+xml","href":"/favicon/favicon.svg"},{"href":"/favicon/favicon.ico","rel":"shortcut icon"},{"href":"/manifest.json","rel":"manifest"},{"rel":"apple-touch-icon","href":"/favicon/apple-touch-icon.png","sizes":"180x180"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-R6YELD841G","async":true},{"innerHTML":"\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag(){dataLayer.push(arguments);}\n                    gtag('js', new Date());\n                    gtag('config', 'G-R6YELD841G');\n                  ","type":"text/javascript"}],"noscript":[],"htmlAttrs":{"lang":"fa-IR","dir":"rtl","translate":"no"},"__dangerouslyDisableSanitizers":["script","iframe","noscript"]}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true